import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import ReactMarkdown from "react-markdown";

function Timeline({ education }) {
  const { years, title, content } = education;
  return (
    <AnimationOnScroll
      animateIn="animate__fadeInUp"
      animateOut="animate__fadeOutDown"
      animateOnce={true}
    >
      <div className="timeline-container">
        <div className="content">
          <span className="time">{years}</span>
          <h3 className="title">{title}</h3>
          <p><ReactMarkdown>{content}</ReactMarkdown></p>
        </div>
      </div>
    </AnimationOnScroll>
  );
}

export default Timeline;
